export default __webpack_public_path__ + "8fcf62ab17eed7e4773c1f3cea12f3fa.png";